import CreateButton from '@common/components/Button/ShareScreenButton/CreateAppButton';
import { HOME_URL } from '@common/constants/shared';
import { useParams } from '@common/routes/hooks';
import React, { useCallback, useEffect, useMemo } from 'react';
import {
  SafeAreaView,
  View,
  Text,
  Platform,
  NativeModules,
} from 'react-native';
import IFrame from '@common/components/iframe';
import RenderAppDetail from '@common/components/RenderAppDetail';
import styles from './style';
import { WebView } from 'react-native-webview';
import useAppDetail from '@common/hooks/app';
import { useSelector } from 'react-redux';
import { dimensionSelector } from '@common/redux/selectors/page';
import appConfig from '../../../appConfig.json';
import ShareCustomDomain from './ShareScreenCustomDomain';
import { checkMobileLayout, copyToClipboard } from '@common/utils/screen';
import useSocketConnection from '@common/hooks/useSocketAuthentication';
import Loading from '@common/components/Loading';
import Render from '../RenderScreen';
import { setupManifest } from '@common/utils/setupManifest';
import { useCollections } from '@common/hooks/collections';

const subDomainBlockList = [
  'app',
  'lp',
  'news',
  'community',
  'admin',
  'share',
  'dev',
  'developer',
  'application',
  'sample',
  'test',
  'click',
  'nocode',
  'nocodejapan',
  'ncj',
];

const ShareScreenView = ({ appId }: any) => {
  const { isLoading, data } = useAppDetail({
    appId: appId,
    isShareScreen: true,
  });
  useCollections({ appId });

  useEffect(() => {
    setupManifest(appId, data);
  }, [appId, data]);

  const urlSearchParams = new URLSearchParams(window.location.search);
  let newUri = `https://share.click.dev/preview/${appId}?hiddenStatusBar=true`;
  if (urlSearchParams.has('locale')) {
    const locale = urlSearchParams.get('locale');
    newUri = newUri + `&locale=${locale}` + `&pwa=true`;
  }
  if (urlSearchParams.has('code') && urlSearchParams.has('type')) {
    const code = urlSearchParams.get('code');
    const type = urlSearchParams.get('type');
    newUri = newUri + `&code=${code}&type=${type}`;
  }
  if (urlSearchParams.has('masterId')) {
    const masterId = urlSearchParams.get('masterId');
    newUri = newUri + `&masterId=${masterId}`;
  }
  if (urlSearchParams.has('login_url')) {
    const login_url = urlSearchParams.get('login_url') ?? '';
    newUri = newUri + `&login_url=${encodeURIComponent(login_url)}`;
  }

  return (
    <WebView
      source={{ uri: newUri }}
      style={{
        width: '100%',
        height: '100dvh',
      }}
      scalesPageToFit={true}
    />
  );
};

const ShareScreen = ({ appId }: any) => {
  const currentHostName = window.location.hostname;
  const regexHost = /(\.click\.dev|\.gotravel\.city)$/;

  // browser mobile
  const isMobile = () => {
    try {
      document.createEvent('TouchEvent');
      return true;
    } catch (e) {
      return false;
    }
  };

  // authentication SocketIO (forced to run first !)
  if (appId) {
    const { loading: reAuthLoading } = useSocketConnection();
    if (reAuthLoading) {
      return <Loading />;
    }
  }

  if (Platform.OS == 'web') {
    const urlSearchParams = new URLSearchParams(window.location.search);

    const isState = urlSearchParams.has('state');
    const state = urlSearchParams.get('state');
    if (isState) {
      const codeAuth = urlSearchParams.get('code');
      const isLineBrowser = navigator.userAgent.indexOf('Line/') !== -1;
      // line browser
      if (state && isLineBrowser) {
        let path: any = state;
        if (path.includes('/preview')) {
          path = path.replace('/preview', '') + `?code=${codeAuth}&type=line`;
        }
        if (path.includes('/share-app')) {
          path = path.replace('/share-app', '') + `?code=${codeAuth}&type=line`;
        }
        window.location.href = window.location.origin + path;
        return null;
      }

      // web browser
      if (state?.includes('/preview') || state?.includes('/share-app')) {
        const url = new URL(
          state.replace('/preview', '').replace('/share-app', '')
        );
        url.searchParams.set('code', codeAuth || '');
        url.searchParams.set('type', 'line');
        window.location.href = url.href;
        return (
          <View>
            <Text>Redirect...</Text>
          </View>
        );
      }
      // web browser on native-app
      if (isMobile()) {
        const launchApp = () => {
          // redirect to app
          window.location.replace(`${state}://?code=${codeAuth}`);
        };
        if (state && codeAuth) launchApp();
        return null;
      }
    }

    return <ShareScreenView appId={appId} />;
  } else {
    return (
      <View>
        <Text>Cannot support for OS version</Text>
      </View>
    );
  }
};

export default ShareScreen;
